module.exports = __webpack_public_path__ + "static/Slide01@2x.d2995308.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/events/new/Slide01@2x.png
// module id = 703
// module chunks = 216210090109534